<template>
  <div>
    <footer class="main-footer row">
      <div class="container">
        <div
          class="
            d-flex
            flex-lg-row flex-column
            justify-content-center
            align-items-center
            justify-content-lg-between
          "
        >
          <div class="m-0 mr-lg-5 text-center text-lg-left">
            <router-link to="/">
              <img
                src="@/assets/images/logo.svg"
                alt="TotalPass Logotipo"
                style="max-width: 170px"
              />
            </router-link>
            <p>Total Pass © - todos os direitos reservados</p>
          </div>

          <div>
            <h4>Acompanhe</h4>
            <nav class="navbar navbar-dark p-0 m-0">
              <ul class="d-flex align-items-center m-0 p-0">
                <li class="nav-item">
                  <a href="https://pt-br.facebook.com/totalpassoficial/" target="_blanck">
                    <img src="@/assets/images/btn-facebook.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a href="https://www.instagram.com/totalpassoficial/ " target="_blanck">
                    <img src="@/assets/images/btn-instagram.svg" alt="" />
                  </a>
                </li>
                <li class="nav-item ml-4">
                  <a href="https://www.linkedin.com/company/totalpassoficial" target="_blanck">
                    <img src="@/assets/images/btn-linkedin.svg" alt="" />
                  </a>
                </li>
                <!-- <li class="nav-item ml-4">
                  <a href="" target="_blanck">
                    <img src="@/assets/images/btn-youtube.svg" alt="" />
                  </a>
                </li> -->
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",

  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },

  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
.main-footer {
  background-color: rgba(theme-color(dark), 0.8);
  color: #fff;
  padding: 4rem 0px;
  font-family: "Poppins", sans-serif;
  @include media-breakpoint-down(md) {
    text-align: center;
  }
  p {
    font-size: 1.4rem;
    font-weight: 300 !important;
    margin-top: 1.5rem;
  }
  h4 {
    font-family: "Poppins", sans-serif;
    font-style: italic;
    font-weight: 500;
    margin: 0px 0px 2rem 0.8rem;
  }
}

li {
  margin: 0px;
  padding: 0px;
  a {
    margin-left: 0.8rem;
    img {
      width: 30px;
    }
  }
}
.nav-link {
  color: theme-color(dark) !important;
  padding: 0px !important;
  font-size: 1.3rem;
  font-weight: bold;
  &:hover {
    color: theme-color(primary) !important;
  }
}
</style>